module.exports = __webpack_public_path__ + "img/logo_ubbi_white.dde5847c.png";